import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { PollWithQuestionsResponse } from '../../../../api/types/settings/settings-all';
import { deletePollOperation } from '../operations/delete-poll-operation';

interface DeletePollConfirmDialogProps {
  poll: PollWithQuestionsResponse;
  closeDialog: () => void;
}

export const DeletePollConfirmDialog: React.FC<
  DeletePollConfirmDialogProps
> = ({ poll, closeDialog }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    await deletePollOperation(poll.id, setLoading, closeDialog);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <i
        className="pi pi-exclamation-triangle"
        style={{
          fontSize: '3rem',
          color: '#f59e0b',
          marginBottom: '16px',
        }}
      />
      <p style={{ fontSize: '1.1rem', marginBottom: '8px' }}>
        האם אתה בטוח שברצונך למחוק את המשוב?
      </p>
      <p
        style={{
          fontSize: '1.2rem',
          fontWeight: 'bold',
          color: '#1f2937',
          marginBottom: '16px',
        }}
      >
        "{poll.pollName}"
      </p>
      {poll.questions && poll.questions.length > 0 && (
        <p
          style={{
            fontSize: '0.9rem',
            color: '#dc2626',
            marginBottom: '16px',
          }}
        >
          <i className="pi pi-info-circle" style={{ marginLeft: '4px' }} />
          משוב זה מכיל {poll.questions.length} שאלות שיימחקו גם כן
        </p>
      )}
      <p style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '24px' }}>
        פעולה זו אינה ניתנת לביטול
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
        <Button
          label="ביטול"
          icon="pi pi-times"
          className="p-button-outlined p-button-secondary"
          onClick={closeDialog}
          disabled={loading}
        />
        <Button
          label="מחיקה"
          icon="pi pi-trash"
          className="p-button-danger"
          onClick={handleDelete}
          loading={loading}
        />
      </div>
    </div>
  );
};
